import { render, staticRenderFns } from "./SearchArrow.vue?vue&type=template&id=67d87b5c&"
import script from "./SearchArrow.vue?vue&type=script&lang=js&"
export * from "./SearchArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports